import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
export const Card = ({ children, className }) => {
    const { Card: theme } = useTheme('InsurancePage');
    return React.createElement("div", { className: cn(theme.card, className) }, children);
};
